'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'files';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e178';
var svgPathData = 'M96 64c0-35.3 28.7-64 64-64L293.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L448 384c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64L96 64zm192 72c0 13.3 10.7 24 24 24l77.5 0-101.5-101.5 0 77.5zM48 120l0 360c0 8.8 7.2 16 16 16l264 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L64 544c-35.3 0-64-28.7-64-64L0 120c0-13.3 10.7-24 24-24s24 10.7 24 24z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFiles = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;